/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Finance_LeadInputs */

const en_features_finance_lead = /** @type {(inputs: Features_Finance_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your finances in one place.`)
};

const pl_features_finance_lead = /** @type {(inputs: Features_Finance_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanse w jednym miejscu.`)
};

/**
* | output |
* | --- |
* | "Your finances in one place." |
*
* @param {Features_Finance_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_finance_lead = /** @type {((inputs?: Features_Finance_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Finance_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_finance_lead(inputs)
	return en_features_finance_lead(inputs)
});